import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { getListCourse } from "../services";
import { useInfiniteScroll } from "entities/community/components/useInfiniteScroll";
import { Link } from "@shopify/polaris";
import { debounce } from "lodash";
import logoIkes from "../../../media/logo-ikes.png";
const EvaluationStudent = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [fetchedCourses, setFetchedCourses] = useState<any[]>([]);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchQuery(searchTerm);
    }, 500);
    return () => clearTimeout(delaySearch);
  }, [searchTerm]);

  const fetchCourses = async () => {
    try {
      const response = await getListCourse({
        page: 1,
        limit: 12,
        order_by: "DESC",
        search: searchQuery,
      });
      setFetchedCourses(response.data);
      reset(response.data);
    } catch (err) {
      console.error("Error fetching courses:", err);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, [searchQuery]);

  const {
    items: listCourse,
    loading,
    hasMore,
    reset,
  } = useInfiniteScroll(
    getListCourse,
    {
      order_by: "DESC",
      search: searchQuery,
    },
    { initialLimit: 12 }
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const renderItem = (item) => {
    return (
      <Box
        sx={{
          cursor: "pointer",
        }}
      >
        <img
          src={item.avatar?.media_url || logoIkes}
          style={{
            height: 180,
            width: "100%",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
          }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = logoIkes;
          }}
        />
        <Typography
          sx={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 3,
            overflow: "hidden",
            textOverflow: "ellipsis",
            lineHeight: "1.5em",
            padding: "8px",
          }}
          variant="subtitle1"
          fontSize={14}
        >
          {item?.title}
        </Typography>
      </Box>
    );
  };
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1450px",
        // padding: "20px",
        margin: "0 auto",
        bgcolor: "#fff",
        padding: 2,
      }}
    >
      <Box>
        <Typography variant="h5" fontWeight={550}>
          Đánh giá
        </Typography>
        <TextField
          fullWidth
          label="Tìm kiếm khóa học"
          value={searchTerm}
          onChange={handleSearchChange}
          variant="outlined"
          margin="normal"
        />
      </Box>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
            lg: "1fr 1fr 1fr 1fr",
            xl: "1fr 1fr 1fr 1fr 1fr",
          },
          gap: 2,
          width: "100%",
        }}
      >
        {listCourse.map((item: any, index) => (
          <Box
            sx={{
              borderRadius: 3,
              bgcolor: "white",
              boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
            }}
            key={index}
          >
            <Link url={item._id}>{renderItem(item)}</Link>
          </Box>
        ))}
      </Box>

      {!loading && hasMore && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default EvaluationStudent;
